import { Pipe, PipeTransform } from '@angular/core';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger('DishTextPipe');
@Pipe({
  name: 'changeDishText',
})
export class ChangeDishTextPipe implements PipeTransform {
  transform(dishText: string) {
    if (dishText.indexOf('Dish') >= 0) {
      const values = dishText.split(' ');
      if (values[0].toLowerCase() === 'dish') {
        values.splice(0, 1, 'Selection');

        return values.join(' ');
      }
    } else {
      return dishText;
    }
  }
}
